import * as React from 'react';
import { AdacText } from '@adac-de/component-library';
import { clsx } from 'clsx';
import styles from './error-text.module.scss';

type ErrorTextProps = {
  text: string;
  className?: string;
};

export const ErrorText: React.FC<ErrorTextProps> = ({ text, className }) => (
  <div className={clsx(styles.errorText, className)}>
    <AdacText type="small" color="highlightRed">
      {text}
    </AdacText>
  </div>
);
